export var Theme2 = {
    primary: {
        50: { hex: '#8E8E8E', contrast: '#ffffff' },
        100: { hex: '#a3a3a3', contrast: '#ffffff' },
        200: { hex: '#6e6e6e', contrast: '#ffffff' },
        300: { hex: '#3d3d3d', contrast: '#ffffff' },
        400: { hex: '#666666', contrast: '#ffffff' },
        500: { hex: '#262626', contrast: '#ffffff' },
        600: { hex: '#000000', contrast: '#ffffff' },
        700: { hex: '#000000', contrast: '#ffffff' },
        800: { hex: '#000000', contrast: '#ffffff' },
        900: { hex: '#000000', contrast: '#ffffff' },
        A100: { hex: '#ffffff', contrast: '#000000' },
        A200: { hex: '#ffffff', contrast: '#000000' },
        A400: { hex: '#f1f1f1', contrast: '#000000' },
        A700: { hex: '#666666', contrast: '#ffffff' },
        contrastDefaultColor: 'light'
    },
    theme: {
        50: { hex: '#effff0', contrast: '#000000' },
        100: { hex: '#e0f5e1', contrast: '#000000' },
        200: { hex: '#d7edd8', contrast: '#000000' },
        300: { hex: '#86FF8D', contrast: '#000000' },
        400: { hex: '#71DE77', contrast: '#000000' },
        500: { hex: '#48D74F', contrast: '#000000' },
        600: { hex: '#32B539', contrast: '#000000' },
        700: { hex: '#209326', contrast: '#ffffff' },
        800: { hex: '#237A28', contrast: '#ffffff' },
        900: { hex: '#084F0C', contrast: '#ffffff' },
        A100: { hex: '#084F0C', contrast: '#ffffff' },
        A200: { hex: '#084F0C', contrast: '#ffffff' },
        A400: { hex: '#d7edd8', contrast: '#000000' },
        A700: { hex: '#d7edd8', contrast: '#000000' },
        contrastDefaultColor: 'dark'
    }
};
